<template>
    <el-dialog :visible.sync="show" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false"
        center width="40%" class="dialog">
        <img :src="img" alt="" />
        <p class="tips">{{ desc }}</p>

        <span slot="footer" class="dialog-footer">
            <el-button class="btn left" type="primary" @click="$emit('onConfirm', true)">确 定</el-button>
            <el-button class="btn" @click="$emit('onConfirm', false)">取 消</el-button>
        </span>
    </el-dialog>
</template>

<script>
    export default {
        props: {
            // 显现隐藏
            show: {
                type: Boolean,
                default: false,
            },
            // 图片
            img: {
                type: String,
                default: require("@/assets/images/icons/icon_zhuyi.png"),
            },
            // 提示文字
            desc: {
                type: String,
                default: "请确定要删除该团队吗？",
            },
        },
    };
</script>

<style lang="less" scoped>
    ::v-deep .dialog {
        .el-dialog {
            border-radius: 10px;

            .el-dialog__body {
                padding-top: 50px;
                text-align: center;

                .tips {
                    margin-top: 30px;
                    font-size: 21px;
                    color: #666666;
                }
            }

            .el-dialog__footer {
                padding-top: 60px;
                padding-bottom: 80px;

                .btn {
                    width: 120px;
                    height: 44px;
                    border-radius: 4px;
                    font-size: 16px;

                    &.left {
                        margin-right: 42px;
                    }
                }
            }
        }
    }
</style>